import $ from 'jquery';
import {show} from './FollowData';


export class ShareClassHeader {

  constructor(){

    this.customSelects$ = $(".ar-share-class-header")
    this.secondaryNav$ = $(".ar-share-class-nav");
    this.backToTop$ = $(".ar-back-to-top");
    this.init();
    this.latestY = 0;
    this.oldY = 0;
    this.ticking = false; 
    this.thresholds = { 'back_to_top': $(window).height(), 'fund_nav': 200 };
    this.status = { 'back_to_top': 0, 'fund_nav': 0 }
  }

  init(){

    this.customSelects$.on('change', (e)=> {
      let url = $(e.target).val();
      if(url){
        window.location = url;
      }
    })
    
    $(window).on('scroll', $.proxy(this.onScroll, this) );

    //Follow fund functionality
    show(".ar-follow-share-class")

    this.secondaryNav$.on('click', 'li', (e) => {
        var anchor = $(e.currentTarget).find('a').attr('href').replace('#', '');
        this.scrollToItem( 'a[name="' + anchor + '"]' );
        e.preventDefault;
    })

    this.backToTop$.on('click', (e) => { this.scrollToItem('.ar-share-class-header'); });

  }

  onScroll() {
      this.latestY = window.pageYOffset;
      if(!this.ticking) {
          requestAnimationFrame($.proxy(this.fundScroll, this));
      }
      this.ticking = true;
  }

  fundScroll(e) {
      this.ticking = false; 
      var thresholds = {
        'back_to_top': this.testThreshold('back_to_top', 'mobile'),
        'fund_nav': this.testThreshold('fund_nav', 'desktop')
      }
      switch (thresholds.back_to_top) {
          case 1: this.backToTop$.addClass('is-visible'); break;
          case -1: this.backToTop$.removeClass('is-visible'); break;
      } 
      switch (thresholds.fund_nav) {
          case 1: this.secondaryNav$.addClass('is-fixed'); break;
          case -1: this.secondaryNav$.removeClass('is-fixed'); break;
      } 
      this.oldY = this.latestY; 
  }

  scrollToItem( selector ) {
      var pos = $( selector ).position();
      $("html, body").animate({ scrollTop: (pos.top + 170) + "px" });
  }

  testThreshold( name, viewport ) {
      var shouldTest = !viewport || (($(window).width() < 768)? (viewport == 'mobile') : (viewport == 'desktop'));
      if (!shouldTest) return 0;
      var vh = this.thresholds[ name ];
      var passedBar = (this.latestY > vh)? ((this.oldY <= vh)? 1 : 0) : ((this.oldY >= vh)? -1 : 0);
      return passedBar;
  } 
  
}
